<!-- !!!TODO!!! Scroll position is not updating as computed property... We could also use v-scroll which should be faster... Otherwise add 100ms debounce -->
<template>
  <div
    :class="['status', 'status--' + status]"
  />
  <!--<div
    :class="['status', 'status--' + status]"
    :style="'background-position-x: ' + scrollPos"
  />-->
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: 'default',
      validator (values) {
        return ['default', 'loading', 'success', 'error'].includes(values)
      }
    }
  },
  data () {
    return {
      scrollPos: 0
    }
  },
  computed: {
    scrollPercent () {
      return this.handleScroll()
    },
  },
  methods: {
    handleScroll() {
     /* let scrollTop = document.scrollingElement.scrollTop
      let docHeight = document.body.scrollHeight
      let winHeight = window.innerHeight
      let scrollPercent = Math.round(((scrollTop) / (docHeight - winHeight)) * 100)
this.scrollPos = scrollPercent
console.log(this.scrollPos)*/
     // return scrollPercent
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  unmounted () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.status {
  position: absolute;
  top: -1px;
  width: 100%;
  height: 100%;
  //background-color: $bg-2;

  &--loading {
    background-image: linear-gradient(90deg, $blue 0%, $green 17%, $yellow 34%, $orange 51%, $pink 68%, $purple 84%, $blue 100%);
    background-position: 0 0;
    background-repeat: repeat-x;
    animation: loadingAnimation 1s linear infinite;
  }

  &--success {
    background-color: $success;
    background-position: 0 0;
    background-repeat: no-repeat;
    animation: successAnimation 1s ease-out 1;
    opacity: 0;
  }

  &--error {
    background-color: $error;
    background-position: 0 0;
    background-repeat: no-repeat;
    animation: errorAnimation 2s ease-out 1;
    opacity: 0;
  }
}

@keyframes loadingAnimation {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 100vw 0;
  }
}

@keyframes successAnimation {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes errorAnimation {
  0% {
    opacity: 1;
  }
  33% {
    opacity: 0;
  }
  66% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>


<!--

  OLD Progress.vue


  <template>
  <div
    class="progress"
  >
    <div
      class="progress__bar"
    >
      <div
        class="progress__bar__shade1"
        :class="mode !== '' ? ('progress__bar__shade1--'+mode) : ''"
      />
      <div
        class="progress__bar__shade2"
        :class="mode !== '' ? ('progress__bar__shade2--'+mode) : ''"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .progress {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 6px;
    z-index: 10001;
    background: linear-gradient(to right, orange , yellow, green, cyan, blue, violet);
    &__bar {
      position: relative;
      height: 6px;
      width: 100%;
      &__shade1 {
        position: absolute;
        background: rgba(0,0,0,0.5);
        height: 100%;
        width: 0;
        left: 0;
        &--indeterminate {
          animation-duration: 2s;
          animation-timing-function: ease;
          animation-name: indeterminate1;
          animation-iteration-count: infinite;
        }
      }
      &__shade2 {
        position: absolute;
        background: rgba(0,0,0,0.5);
        height: 100%;
        width: 100%;
        right: 0;
        &--indeterminate {
          animation-duration: 2s;
          animation-timing-function: ease;
          animation-name: indeterminate2;
          animation-iteration-count: infinite;
        }
      }
    }
  }

  @keyframes indeterminate1 {
    0% {
      width: 0;
    }
    50% {
      width: 50%;
    }
    100% {
      width: 100%;
    }
  }
  @keyframes indeterminate2 {
    0% {
      width: 100%;
    }
    50% {
      width: 20%;
    }
    100% {
      width: 0;
    }
  }
</style>



-->